
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/v6-beta-pickers",
      function () {
        return require("private-next-pages/blog/v6-beta-pickers.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/v6-beta-pickers"])
      });
    }
  